import React from 'react';
import GameCardSkeleton from './GameCardSkeleton';

interface GameListSkeletonProps {
  count?: number;
  className?: string;
}

const GameListSkeleton: React.FC<GameListSkeletonProps> = ({ 
  count = 12, 
  className = '' 
}) => {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 ${className}`}>
      {Array.from({ length: count }, (_, index) => (
        <GameCardSkeleton key={index} />
      ))}
    </div>
  );
};

export default GameListSkeleton;

